import React from 'react';
import WipAppsheetOrderItemsBrowserPage from './wip/WipAppsheetOrderItemsBrowserPage.jsx';

const AppsheetOrderItemsPage = () => <WipAppsheetOrderItemsBrowserPage />;

export default AppsheetOrderItemsPage;
